export function isvalidPhone(rule, value, callback) {
    const reg = /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/;
    // return reg.test(str)
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error("手机号不正确"));
    }
  }
  